module.exports = __webpack_public_path__ + "assets/img/tj_list_item_back.9bc87fd9.png";